

export default {
  name: 'PresenceIcon',
  props: {
    serviceClass: String,
    url: String
  }
};
